import React, { Fragment } from 'react'
import { useInfiniteQuery } from 'react-query'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Loader from '../shared/loader'
import { UserCardBox } from './user-card-box'
import Button from '../shared/sn-button'
import { findFacebookFriends } from '../../../components/contacts-finder/facebook-contacts'

const LIMIT_USERS_PER_REQUEST = 12

const FacebookFriends = () => {
    const { t } = useTranslation()
    const authedUser = useSelector(state => state.auth.user)

    const {
        data,
        isLoading,
        canFetchMore,
        isFetchingMore,
        fetchMore,
    } = useInfiniteQuery([LIMIT_USERS_PER_REQUEST], findFacebookFriends, {
        getFetchMore: lastItem => {
            const cursor = lastItem?.meta?.cursor
            // If request returns less then asks users
            // then it means that there's no more users to get
            const shouldFetchMore = cursor.count === LIMIT_USERS_PER_REQUEST
            return shouldFetchMore && lastItem?.meta?.cursor?.next
        },
        refetchOnWindowFocus: false,
        enabled: true,
    })

    if (isLoading) {
        return <Loader />
    }

    return (
        <div className="container-fluid pb-5">
            <div className="container w-100 pt-sm-0 pt-5 d-flex flex-column">
                <h2 className="pt-4">{t('community.usersFromFacebook')}</h2>
                <div className="row">
                    {data?.map((users, index) => (
                        <Fragment key={index}>
                            {users?.data?.map?.(userData => (
                                <div key={userData.id} className="col-xs-12 col-sm-6 col-md-4 col-lg-3 mb-2">
                                    <UserCardBox
                                        user={userData}
                                        authedUser={authedUser}
                                    />
                                </div>
                            ))}
                        </Fragment>
                    ))}
                </div>
                {isFetchingMore && <Loader />}
                {canFetchMore && (
                    <Button
                        onClick={() => fetchMore()}
                        className="btn btn-outline-color-neutral btn-circle mx-auto mt-3"
                    >
                        {t('showMore')}
                        <i className="ml-2 fa fa-chevron-down" />
                    </Button>
                )}
            </div>
        </div>
    )
}

export default FacebookFriends
